<template>
  <div>
    <!--Banner-->
    <div class="uk-cover-container">
      <BannerComponent :banner-url="bannerUrl" :title="title"/>
    </div>

    <div class="uk-container">

      <!--Description-->
      <PropertySectionOne :description="'turtle_nest.para_1'|translate"/>

      <!--Slider-->
<!--      <PropertySectionTwo :slide-items="slideItems"/>-->

      <!--Map-->
      <!--<PropertySectionThree
        :moto="title"
        :description="'turtle_nest.para_2'|translate"
        :embedded-map-url="embeddedMapUrl"
      />-->
      <!--Features-->
      <!--<PropertySectionSix
        :description="'turtle_nest.features.para'|translate"
        :features="features"
      />-->

      <!--Thumbnav-->
<!--      <PropertySectionFour :slide-items="thumbNavItems"/>-->

      <!--Packages-->
<!--      <PropertySectionFive :packages="packages"/>-->

    </div>

  </div>

</template>

<script>
import BannerComponent from '../components/BannerComponent'
import PropertySectionOne from '../components/properties/PropertySectionOne'
// import PropertySectionTwo from '../components/properties/PropertySectionTwo'
// import PropertySectionThree from '../components/properties/PropertySectionThree'
// import PropertySectionFour from '../components/properties/PropertySectionFour'
// import PropertySectionFive from '../components/properties/PropertySectionFive'
// import PropertySectionSix from '../components/properties/PropertySectionSix'
import store from '../store'

export default {
  name: 'PropertyTurtle',
  components: {
    BannerComponent,
    PropertySectionOne
    // PropertySectionTwo,
    // PropertySectionThree,
    // PropertySectionFour,
    // PropertySectionFive,
    // PropertySectionSix
  },

  data: function () {
    return {
      propertyId: 3,
      title: store.state.property.turtle.location,
      description: store.state.property.turtle.description,
      bannerUrl: store.state.property.turtle.bannerUrl,
      slideItems: store.state.property.turtle.slideItems,
      embeddedMapUrl: store.state.property.turtle.embeddedMapUrl,
      thumbNavItems: store.state.property.turtle.thumbNavItems,
      packages: store.state.property.turtle.packages,
      features: store.state.property.turtle.features
    }
  },
  mounted () {
    this.fetchPriceList()
    this.fetchDeals()
    this.fetchFoods()
  },
  methods: {
    fetchPriceList () {
      this.$store.dispatch('property/fetchPropertyPriceList', { propertyId: this.propertyId })
    },
    fetchDeals () {
      this.$store.dispatch('property/fetchPropertyDeals', { propertyId: this.propertyId })
    },
    fetchFoods () {
      this.$store.dispatch('property/fetchPropertyFoods', { propertyId: this.propertyId })
    }
  }
}
</script>

<style scoped>

</style>
